export default __webpack_public_path__ + "static/media/react.d6e88ce4.png";